import { Container, Row, Col } from "react-bootstrap";
import plus from "../../../../assets/images/+.png";
import "./index.scss";

const ProcessSection = () => {
  const Desktop = () => {
    return (
      <section id="process" className="process-section">
        <Container data-aos="fade-up">
          <Row>
            <Col>
              <h2 className="title">PROCESS</h2>
              <div className="w-100 processes">
                <div className="process-item">
                  <div className="item-title">
                    <h3>APPLICATION</h3>
                  </div>
                  <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                    6 DECEMBER 2022 <br /> 8 JANUARY 2023
                  </div>
                </div>
                <img
                  src={plus}
                  width="21px"
                  height="21px"
                  alt="plus"
                  className="plus"
                />
                <div className="process-item">
                  <div className="item-title">
                    <h3>
                      PRE- <br />
                      EVALUATION
                    </h3>
                  </div>
                  <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                    9-10
                    <br /> JANUARY 2023
                  </div>
                </div>
                <img
                  src={plus}
                  width="21px"
                  height="21px"
                  alt="plus"
                  className="plus"
                />
                <div className="process-item">
                  <div className="item-title">
                    <h3>
                      GENERAL
                      <br /> APTITUDE TEST
                      <br /> ENGLISH <br />
                      PROFICIENCY TEST
                    </h3>
                  </div>
                  <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                    11-18 <br />
                    JANUARY 2023
                  </div>
                </div>
                <img
                  src={plus}
                  width="21px"
                  height="21px"
                  alt="plus"
                  className="plus"
                />
                <div className="process-item">
                  <div className="item-title">
                    <h3>
                      CV <br />
                      EVALUATION
                    </h3>
                  </div>
                  <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                    19-27
                    <br />
                    JANUARY 2023
                  </div>
                </div>
                <img
                  src={plus}
                  width="21px"
                  height="21px"
                  alt="plus"
                  className="plus"
                />
                <div className="process-item">
                  <div className="item-title">
                    <h3>
                      SELECTION <br /> OF
                      <br /> PARTICIPANTS
                    </h3>
                  </div>
                  <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                    30 JANUARY <br />
                    17 FEBRUARY 2023
                  </div>
                </div>
                <div className="line"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  };

  const Mobile = () => {
    return (
      <section id="process" className="mobile-process-section">
        <Container data-aos="fade-up">
          <Row>
            <Col>
              <h2 className="title">PROCESS</h2>
              <div className="w-100 processes">
                <div>
                  <div className="process-item">
                    <div className="item-title">
                      <h3>APPLICATION</h3>
                    </div>
                    <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                      6 DECEMBER 2022 <br /> 8 JANUARY 2023
                    </div>
                  </div>
                  <img
                    src={plus}
                    width="21px"
                    height="21px"
                    alt="plus"
                    className="plus"
                  />
                  <div className="process-item">
                    <div className="item-title">
                      <h3>
                        PRE- <br />
                        EVALUATION
                      </h3>
                    </div>
                    <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                      9-10
                      <br /> JANUARY 2023
                    </div>
                  </div>
                  <div className="line"></div>
                </div>
                <div>
                  <div className="process-item">
                    <div className="item-title">
                      <h3>
                        GENERAL
                        <br /> APTITUDE TEST
                        <br /> ENGLISH <br />
                        PROFICIENCY TEST
                      </h3>
                    </div>
                    <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                      11-18 <br />
                      JANUARY 2023
                    </div>
                  </div>
                  <img
                    src={plus}
                    width="21px"
                    height="21px"
                    alt="plus"
                    className="plus"
                  />
                  <div className="process-item">
                    <div className="item-title">
                      <h3>
                        CV <br />
                        EVALUATION
                      </h3>
                    </div>
                    <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                      19-27
                      <br />
                      JANUARY 2023
                    </div>
                  </div>
                  <div className="line"></div>
                </div>
                <div>
                  <div className="process-item">
                    <div className="item-title">
                      <h3>
                        SELECTION <br /> OF
                        <br /> PARTICIPANTS
                      </h3>
                    </div>
                    <div className="item-desc d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 text-center">
                      30 JANUARY <br />
                      17 FEBRUARY 2023
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    );
  };

  return window.innerWidth < 600 ? <Mobile /> : <Desktop />;
};

export default ProcessSection;
